// TODO: Add test
export const splitAtIndex = <T>(
  arr: T[],
  idx: number
): { active: T[]; inactive: T[] } => {
  const active = arr.slice(0, idx + 1)
  const inactive = arr.slice(idx + 1, arr.length)
  return { active, inactive }
}
